import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useEffect,
} from 'react';
import {Text, View, TextInput} from 'react-native';
import {useModal} from '@components/basic/modal';
import {
  padding,
  background,
  flex,
  position,
  borderRadius,
  font,
  fontColor,
  basicColor,
} from '@/components/style';
import LazyImage from '@/components/basic/image';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';

import {
  w24,
  h24,
  w295,
  margintb,
  fontSize18,
  height48,
  delIcon,
  del,
  pos,
} from '@/common-pages/profile/profile.variable';
import {fetchUseGiftCode} from '@/pages/me/service';
import globalStore from '@services/global.state';
import {useTranslation} from 'react-i18next';
// import globalStore from '@/services/global.state';
const ModelDemo = (props: any, ref: any) => {
  const {i18n} = useTranslation();
  const [name, seTName] = useState('');
  const [errorMessage, setEerrorMessage] = useState('');
  useEffect(() => {
    if (!name) {
      setEerrorMessage('');
    }
  }, [name]);
  const handleupdateProfile = async () => {
    fetchUseGiftCode({code: name})
      .then(res => {
        globalStore.globalSucessTotal(
          i18n.t('tip.success'),
          <div className="text-center text-white">
            <div>congratulations on receiving</div>
            <div>
              <span className="text-[#F15802]">₹{res.amount}</span>
              <span>reward</span>
            </div>
          </div>,
        );
        // amount
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        hide();
        seTName('');
      });
  };
  const {renderModal, show, hide} = useModal(
    <View style={[w295]}>
      <View style={[flex.flex, flex.alignEnd]}>
        <NativeTouchableOpacity
          onPress={() => {
            setEerrorMessage('');
            hide();
          }}>
          <LazyImage
            occupancy={'transparent'}
            imageUrl={del}
            width={w24}
            height={h24}
          />
        </NativeTouchableOpacity>
      </View>
      <View style={[flex.centerByCol]}>
        <Text style={[fontSize18, {fontWeight: 'bold'}]}>GIFT CODE</Text>
      </View>
      <View style={[position.rel]}>
        <TextInput
          style={[
            background.lightGrey,
            margintb,
            padding.l,
            borderRadius.xs,
            {
              borderColor: '#D8E0EA',
              borderWidth: 1,
              color: fontColor.second,
              fontSize: 14,
              fontWeight: name.trim().length > 1 ? 'bold' : 'normal',
            },
          ]}
          placeholder={'please enter'}
          placeholderTextColor={'#9FA5AC'}
          value={name}
          onChangeText={text => {
            seTName(text);
          }}
          maxLength={16}
        />
        <View style={[position.abs, pos, flex.flex, flex.center]}>
          <NativeTouchableOpacity
            onPress={() => seTName('')}
            style={[flex.flex1, flex.centerByRow, padding.lrl]}>
            <LazyImage
              occupancy={'transparent'}
              imageUrl={delIcon}
              width={14}
              height={14}
            />
          </NativeTouchableOpacity>
        </View>
      </View>
      {errorMessage ? (
        <View style={[{marginBottom: 16, paddingLeft: 10, paddingRight: 10}]}>
          <Text style={[{color: '#ff0000'}]}> {errorMessage}</Text>
        </View>
      ) : null}
      <NativeTouchableOpacity
        onPress={() => {
          handleupdateProfile();
        }}>
        <View
          style={[
            height48,
            {
              backgroundColor: basicColor.primary,
            },
            flex.flex,
            flex.center,
            flex.centerByCol,
            borderRadius.l,
          ]}>
          <Text style={[fontSize18, font.white, font.fm, font.bold]}>
            Confirm
          </Text>
        </View>
      </NativeTouchableOpacity>
    </View>,
    {
      backDropClose: true,
      overlayStyle: {borderRadius: 20},
    },
  );
  useImperativeHandle(ref, () => ({
    show,
    handleSetName: (str: string) => seTName(str),
  }));
  return <View>{renderModal}</View>;
};

export default forwardRef(ModelDemo);
